import type { AppAbility } from '@/shared/lib/casl'

export const LABORATORY_TABS = [
  'analyses',
  'pcr',
  'emergency-notifications',
] as const

export type TLaboratoryTab = (typeof LABORATORY_TABS)[number]

/**
 * Which tabs of Лабораторные исследования a role may open.
 *
 * The section carries one CASL subject, so the tabs are told apart by what a
 * role may *do* in the lab: `update` marks the roles that actually run it and
 * own the analyses queue and ПЦР. A read-only role — therapist, отдел
 * заготовки — reaches this page for the извещения journal alone, which has its
 * own subject and so is checked separately.
 */
export function getVisibleLaboratoryTabs(
  abilities: AppAbility,
): TLaboratoryTab[] {
  const tabs: TLaboratoryTab[] = []

  if (abilities.can('update', 'laboratory')) tabs.push('analyses', 'pcr')
  if (abilities.can('read', 'emergency-notifications')) {
    tabs.push('emergency-notifications')
  }

  return tabs
}
